'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

var _isInteger = require('babel-runtime/core-js/number/is-integer');

var _isInteger2 = _interopRequireDefault(_isInteger);

exports.email = email;
exports.required = required;
exports.minLength = minLength;
exports.maxLength = maxLength;
exports.integer = integer;
exports.oneOf = oneOf;
exports.match = match;
exports.createValidator = createValidator;
exports.validateForm = validateForm;
exports.verifyEmail = verifyEmail;

var _cardValidator = require('card-validator');

var _cardValidator2 = _interopRequireDefault(_cardValidator);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var isEmpty = function isEmpty(value) {
  return value === undefined || value === null || value === '';
};
var join = function join(rules) {
  return function (value, data) {
    return rules.map(function (rule) {
      return rule(value, data);
    }).filter(function (error) {
      return !!error;
    })[0 /* first error */];
  };
};

// I think this function is not use in anywhere...
function email(value) {
  // Let's not start a debate on email regex. This is just for an example app!
  if (!isEmpty(value) && !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(value)) {
    return 'Invalid email address';
  }
}

function required(value) {
  if (isEmpty(value)) {
    return 'Required';
  }
}

function minLength(min) {
  return function (value) {
    if (!isEmpty(value) && value.length < min) {
      return 'Must be at least ' + min + ' characters';
    }
  };
}

function maxLength(max) {
  return function (value) {
    if (!isEmpty(value) && value.length > max) {
      return 'Must be no more than ' + max + ' characters';
    }
  };
}

function integer(value) {
  if (!(0, _isInteger2.default)(Number(value))) {
    return 'Must be an integer';
  }
}

function oneOf(enumeration) {
  return function (value) {
    if (!~enumeration.indexOf(value)) {
      return 'Must be one of: ' + enumeration.join(', ');
    }
  };
}

function match(field) {
  return function (value, data) {
    if (data) {
      if (value !== data[field]) {
        return 'Do not match';
      }
    }
  };
}

function createValidator(rules) {
  return function () {
    var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    var errors = {};
    (0, _keys2.default)(rules).forEach(function (key) {
      var rule = join([].concat(rules[key])); // concat enables both functions and arrays of functions
      var error = rule(data[key], data);
      if (error) {
        errors[key] = error;
      }
    });
    return errors;
  };
}

function validateForm(data) {
  var validatedData = { formError: false };
  (0, _keys2.default)(data).map(function (key) {
    var field = data[key];
    var validatedField = { error: false };
    if (field.required && !field.value) {
      validatedField.error = true;
      validatedField.errorMessage = (field.label || key) + ' is missing';
      validatedField.templateId = 'validation.missing';
      validatedField.templateValues = { field: field.label || key };
      validatedData[key] = validatedField;
      validatedData.formError = true;
      return;
    }
    if (field.length && field.value.length < field.length) {
      validatedField.error = true;
      validatedField.errorMessage = (field.label || key) + ' length is less than ' + field.length;
      validatedField.templateId = 'validation.length';
      validatedField.templateValues = { field: field.label || key, length: field.length };
      validatedData[key] = validatedField;
      validatedData.formError = true;
      return;
    }
    if (field.format === 'agree_terms_n_conditions' && !field.value) {
      validatedField.error = true;
      validatedField.errorMessage = 'Please agree to our Terms and Conditions & Cancellation Policy';
      validatedField.templateId = 'validation.agree_terms_n_conditions';
      validatedData[key] = validatedField;
      validatedData.formError = true;
      return;
    }
    if (field.format === 'avatar_image' && !field.value) {
      validatedField.error = true;
      validatedField.errorMessage = 'Please upload ' + (field.label || key);
      validatedField.templateId = 'validation.avatar_image';
      validatedField.templateValues = { field: field.label || key };
      validatedData[key] = validatedField;
      validatedData.formError = true;
      return;
    }
    if (field.format === 'email') {
      // const emailFormat = /^\w+([\.+-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/; // FUCK THIS REGEX Fucking slow!!!!
      var emailFormat = /^\w+([.+-]\w+)*@\w+([.-]\w+)*\.\w{2,3}$/;
      if (!field.value.match(emailFormat)) {
        validatedField.error = true;
        validatedField.errorMessage = 'Wrong email format';
        validatedField.templateId = 'validation.email_format';
        validatedField.templateValues = { field: field.label };
        validatedData[key] = validatedField;
        validatedData.formError = true;
        return;
      }
    }
    if (field.format === 'credit-card-number') {
      var validation = _cardValidator2.default.number(field.value.replace(/\s/g, ''));
      if (!validation.isValid) {
        validatedField.error = true;
        validatedField.errorMessage = 'Invalid credit card number';
        validatedField.templateId = 'validation.credit_card_format';
        validatedField.templateValues = { field: field.label };
        validatedData[key] = validatedField;
        validatedData.formError = true;
        return;
      }
    }
    if (field.format === 'password') {
      if (field.value.length < 8) {
        validatedField.error = true;
        validatedField.errorMessage = 'Password must be at least 8 characters';
        validatedField.templateId = 'validation.password_format';
        validatedField.templateValues = { field: field.label };
        validatedData[key] = validatedField;
        validatedData.formError = true;
        return;
      }
    }
    if (field.format === 'match-password') {
      if (field.value !== data[field.match].value) {
        validatedField.error = true;
        validatedField.errorMessage = 'Password and Confirm password does not match';
        validatedField.templateId = 'validation.password_match';
        validatedField.templateValues = { field: field.label };
        validatedData[key] = validatedField;
        validatedData.formError = true;
        return;
      }
    }
    if (field.format === 'credit-card-exp') {
      var _validation = _cardValidator2.default.expirationDate(field.value.replace(/\s/g, ''));
      if (!_validation.isValid) {
        validatedField.error = true;
        validatedField.errorMessage = 'Invalid credit expiry date';
        validatedField.templateId = 'validation.credit_card_exp';
        validatedField.templateValues = { field: field.label };
        validatedData[key] = validatedField;
        validatedData.formError = true;
        return;
      }
    }
    if (field.format === 'numeric') {
      if (isNaN(parseFloat(field.value))) {
        validatedField.error = true;
        validatedField.errorMessage = field.label + ' must be a number';
        validatedField.templateId = 'validation.numeric_format';
        validatedField.templateValues = { field: field.label };
        validatedData[key] = validatedField;
        validatedData.formError = true;
        return;
      }
    }
    if (field.format === 'mobile') {
      var mobileNumber = field.value;
      var mobileFormat = /^[0-9|+|\-| |(|)]*$/g;
      var numberCount = mobileNumber.replace(/[^0-9]/g, '').length || 0;
      if (!field.value.match(mobileFormat) || numberCount < 5) {
        validatedField.error = true;
        validatedField.errorMessage = 'Wrong mobile number format';
        validatedField.templateId = 'validation.phone_number_format';
        validatedField.templateValues = { field: field.label };
        validatedData[key] = validatedField;
        validatedData.formError = true;
        return;
      }
    }
    if (!isNaN(parseFloat(field.gt))) {
      if (field.value <= parseFloat(field.gt)) {
        validatedField.error = true;
        validatedField.errorMessage = field.label + ' must be greater than ' + field.gt;
        validatedField.templateId = 'validation.gt';
        validatedField.templateValues = { field: field.label, gt: field.gt.toString() };
        validatedData[key] = validatedField;
        validatedData.formError = true;
        return;
      }
    }
    if (field.choice) {
      if ((0, _keys2.default)(field.value).filter(function (ch) {
        return field.value[ch] ? true : false;
      }).length < field.choice) {
        validatedField.error = true;
        validatedField.errorMessage = 'You must choose at least ' + field.choice + ' ' + (field.label || key);
        validatedField.templateId = 'validation.choice';
        validatedField.templateValues = { field: field.label || key, choice: field.choice };
        validatedData[key] = validatedField;
        validatedData.formError = true;
        return;
      }
    }
    validatedData[key] = validatedField;
  });
  return validatedData;
}

function verifyEmail(mail) {
  var emailRegex = /^\w+([.+-]\w+)*@\w+([.-]\w+)*\.\w{2,3}$/;
  return emailRegex.test(mail) && !isEmpty(mail);
}


//////////////////
// WEBPACK FOOTER
// ./src/utils/validation.js
// module id = 74
// module chunks = 47